import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { IconModule } from '@hglobal/common';

@Component({
  selector: 'pp-currency-label',
  imports: [IconModule],
  templateUrl: './currency-label.component.html',
  styleUrl: './currency-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyLabelComponent {
  readonly currency = input<string>();
  @Input() iconName: string;
  readonly large = input<boolean>();
}
